import React from 'react';

import { Box, Button, Dialog, Heading, Text } from '@betterment/samba-react';

interface Tier {
  range: string;
  rate: string;
}

interface Props {
  tiers: Tier[];
}

const TieredAdvisoryFee: React.FC<Props> = ({ tiers }) => {
  return (
    <>
      <Text
        css={{
          color: 'text',
          fontWeight: 'bold',
        }}
      >
        Annual advisory fee:
      </Text>
      <Text css={{ color: 'text.weak' }}>
        {' '}
        <Dialog overlay="default">
          <Dialog.Trigger asChild={true}>
            <Button variant="textPrimary" css={{ cursor: 'pointer' }}>
              View tiered fee structure
            </Button>
          </Dialog.Trigger>
          <Dialog.Content
            css={{
              p: 'space.400',
            }}
            size="large"
          >
            <Dialog.Title>
              <Heading as="h2" variant="title300" css={{ mb: 'space.150' }}>
                Annual Advisory Fee - Tiered Structure
              </Heading>
            </Dialog.Title>
            <Dialog.Description>
              <Text
                as="p"
                css={{
                  fontSize: 'fontSize.50',
                  marginBottom: 'space.200',
                  color: 'text.weak',
                }}
              >
                Your fee is calculated by the assets that are within a certain tier. Fees are cumulative.
              </Text>
              <Box
                css={{
                  '& table': {
                    width: '100%',
                    borderCollapse: 'collapse',
                  },
                  '& th': {
                    backgroundColor: 'background.neutral',
                    padding: 'space.100',
                    textAlign: 'left',
                    borderBottom: '1px solid',
                    borderColor: 'border',
                  },
                  '& td': {
                    padding: 'space.100',
                    borderBottom: '1px solid',
                    borderColor: 'border',
                  },
                }}
              >
                <table>
                  <thead>
                    <tr>
                      <th>Balance</th>
                      <th>Fee</th>
                    </tr>
                  </thead>
                  <tbody>
                    {tiers.map((tier, i) => (
                      <tr key={tier.range}>
                        <td>{tier.range}</td>
                        <td>
                          {tier.rate}
                          {i === 0 && (
                            <Text
                              as="span"
                              css={{
                                fontSize: 'fontSize.50',
                                marginLeft: 'space.100',
                                color: 'text.weak',
                              }}
                            >
                              (Starting tier)
                            </Text>
                          )}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </Box>
              <Box css={{ display: 'flex', justifyContent: 'flex-end', mt: 'space.400' }}>
                <Dialog.Trigger asChild={true}>
                  <Button variant="solidSecondary">Close</Button>
                </Dialog.Trigger>
              </Box>
            </Dialog.Description>
          </Dialog.Content>
        </Dialog>
      </Text>
    </>
  );
};

export default TieredAdvisoryFee;
